$(document).ready(function () {
  setTimeout(function () {
    $('.logo').addClass('active');

    setTimeout(function () {
      $('.logo').removeClass('active');
      $('.layout-header').removeClass('splash');
      setTimeout(function () {
        window.location.href = "pages/locations.html";
      }, 800);
    }, 2500);
  }, 1000);
});
